import { render, staticRenderFns } from "./MunicipalityEntityDetails.vue?vue&type=template&id=4fccb443&scoped=true&"
import script from "./MunicipalityEntityDetails.vue?vue&type=script&lang=js&"
export * from "./MunicipalityEntityDetails.vue?vue&type=script&lang=js&"
import style0 from "./MunicipalityEntityDetails.vue?vue&type=style&index=0&id=4fccb443&scoped=true&lang=scss&"
import style1 from "./MunicipalityEntityDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fccb443",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fccb443')) {
      api.createRecord('4fccb443', component.options)
    } else {
      api.reload('4fccb443', component.options)
    }
    module.hot.accept("./MunicipalityEntityDetails.vue?vue&type=template&id=4fccb443&scoped=true&", function () {
      api.rerender('4fccb443', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MunicipalityEntityDetails.vue"
export default component.exports